<template>
  <div class="part3-item">
    <video class="image" v-if="videoPath" controls nodownload>
      <source :src="videoPath" type="video/mp4" />
    </video>
    <img v-else :src="coverImage" class="image">
    <div class="title_bg">
      <p class="title">{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    coverImage: {
      type: String,
      default: ''
    },
    videoPath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.part3-item {
  width: 144px;
  height: 145px;
  opacity: 1;
  position: relative;
  background: linear-gradient(270deg,
      rgba(239, 246, 255, 0.55) 0%,
      #ecf4fe 100%);
  box-shadow: 0px 2px 4px 0px #d5e5f7;
  border-radius: 2px;

  &:hover {
    cursor: pointer;
  }

  .image {
    width: 100%;
    height: 100px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    object-fit: fill;
    position: relative;
  }

  .title_bg {
    z-index: 2;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #343f51;
    text-align: left;
    font-style: normal;
    padding: 4px;
    margin: 0;
    display: flex;
    align-items: center;
    height: 40px;

    .title {
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}

@media screen and (max-width: 767px) {
  .part3-item {
    width: 100%;
    height: 200px;
    opacity: 1;
    position: relative;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 1px rgba(213, 232, 227, 1);

    &:hover {
      cursor: pointer;
    }

    .image {
      width: 100%;
      height: 200px;
      opacity: 1;
      background: rgba(255, 255, 255, 1);
      object-fit: fill;
      position: relative;
    }

    .title_bg {
      bottom: 0;
      position: absolute;
      z-index: 2;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #ffffff;
      text-align: left;
      font-style: normal;
      padding: 4px 10px;
      margin: 0;
      width: 100%;
      background: linear-gradient(rgba(116, 165, 255, 0.61) 0%,
          rgba(16, 101, 255, 0.49) 100%),
        #bbdafa;

      .title {
        margin: 0;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/part3/Part3Item.vue